<template>
    <div class="EvolutionAccomp">
        <HeadPage :title="'Accompagnement vers et dans l\'emploi'" 
                  :category="'Evolution professionnelle'"
                  :img="'evolution/accompagnement.jpg'"
                  :imgAlt="'Accompagnement head page'"
                   class="HeadPage-Evolution-Image"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "EvolutionAccomp",
    data() {
        return {
            content: [
                {
                    text: [ `<strong>Tous les actifs doivent être mieux sensibilisés aux enjeux liés à la gestion 
                    de leur parcours professionnel.</strong>`,
                    `Dans un marché du travail en mutation rapide, marqué par des transitions à la fois plus 
                    fréquentes et plus nombreuses, avec des parcours souvent heurtés, l'enjeu de l'actualisation de leurs compétences 
                    et du maintien de leur employabilité devient central pour les actifs, dans l'emploi ou non.`,
                    `<strong>L'offre d'accompagnement doit s'adapter aux besoins et aux aspirations des personnes.</strong>`,
                    `L'ambition de l'accompagnement proposé par <strong>JobStream</strong> est d'informer, et de soutenir et de guider la personne 
                    tout en contribuant à le rendre plus autonome pour l'avenir dans la gestion de son parcours professionnel.`,
                    `Et cela en tenant compte des aspirations de la personne, de l'ensemble des difficultés qui peuvent être les 
                    siennes et des besoins du marché du travail.`,
                    `Tous les actifs, en emploi ou non, n'ont pas besoin d'être accompagnés et a fortiori n'ont pas besoin d'être accompagnés en permanence. 
                    Ainsi, dans certaines circonstances, ils peuvent seulement avoir besoin d'informations et se révéler assez autonomes pour la trouver par eux-mêmes.`,
                    `L'efficacité de l'accompagnement repose très largement sur la compétence de l'accompagnateur.`,
                    `Les consultants(es) <strong>JobStream</strong> disposent d'une connaissance fine et renforcée du marché du travail et de ses perspectives d'évolution. 
                    Ils/Elles réalisent l'évaluation objective des compétences et aptitudes de la personne afin de bien la situer sur le marché du travail.`,
                        ]
                },
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>